import { createColumnHelper } from '@tanstack/react-table';
import { Code, DataTable, Flex } from '@scale/scaleui-radix';

// Define table row type
export type TableRow = {
  header: string;
  value: string | JSX.Element;
  source: string;
  type: string;
  description: string;
  key: string;
  subtypeId: string;
};

const columnHelper = createColumnHelper<TableRow>();

// Define columns outside component
export const getTableColumns = () => [
  columnHelper.display({
    id: 'rowSelection',
    size: 18,
    enableResizing: false,
    enableHiding: false,
    header: function SelectColumnHeader() {
      return (
        <Flex align="center" height="100%" justify="center" width="100%">
          <DataTable.ColumnHeaderSelect />
        </Flex>
      );
    },
    cell: function SelectColumnCell({ row }) {
      return (
        <Flex align="center" height="100%" justify="center" width="100%">
          <DataTable.RowSelect row={row} />
        </Flex>
      );
    },
  }),
  columnHelper.accessor('header', {
    id: 'header',
    header: function HeaderColumnHeader() {
      return 'Column Name';
    },
    cell: function HeaderColumnCell(info) {
      return <DataTable.CellContentDefault>{info.getValue()}</DataTable.CellContentDefault>;
    },
    enableColumnFilter: false,
  }),
  columnHelper.accessor('subtypeId', {
    id: 'subtypeId',
    header: function SubtypeIdColumnHeader() {
      return 'Subtype ID';
    },
    size: 40,
    cell: function IdColumnCell(info) {
      return (
        <DataTable.CellContentDefault>
          <Code color="accent">{info.getValue()}</Code>
        </DataTable.CellContentDefault>
      );
    },
    filterFn: 'includesString',
  }),
  columnHelper.accessor('source', {
    id: 'source',
    header: function SourceColumnHeader() {
      return 'Source';
    },
    size: 80,
    cell: function SourceColumnCell(info) {
      return <DataTable.CellContentDefault>{info.getValue()}</DataTable.CellContentDefault>;
    },
    filterFn: 'includesString',
  }),
  columnHelper.accessor('type', {
    id: 'type',
    header: function TypeColumnHeader() {
      return 'Type';
    },
    size: 50,
    cell: function TypeColumnCell(info) {
      return <DataTable.CellContentDefault>{info.getValue()}</DataTable.CellContentDefault>;
    },
    filterFn: 'includesString',
  }),
  columnHelper.accessor('description', {
    id: 'description',
    header: function DescriptionColumnHeader() {
      return 'Description';
    },
    cell: function DescriptionColumnCell(info) {
      return <DataTable.CellContentDefault>{info.getValue()}</DataTable.CellContentDefault>;
    },
    enableColumnFilter: false,
  }),
  columnHelper.accessor('key', {
    id: 'key',
    header: function KeyColumnHeader() {
      return '';
    },
    cell: function KeyColumnCell(info) {
      return <DataTable.CellContentDefault>{info.getValue()}</DataTable.CellContentDefault>;
    },
    enableHiding: true,
    enableColumnFilter: false,
  }),
];
